import React, { useEffect,useState } from "react";
import { ClipLoader} from 'react-spinners'

import Navbar from "../../components/navbar/Navbar";
import Header from "../../components/header/Header";
import Cards from "../../containers/cards/Cards";

import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import {InteractionStatus} from "@azure/msal-browser";

import "./allmeasurespage.css"

export default function Allmeasures() {

     //authenticate 
     const {instance,inProgress,accounts} = useMsal();
     const isAuthenticated = useIsAuthenticated();
     const request = { ...loginRequest,account: accounts[0]};
     const [accessToken,setAccessToken] = useState('');
     const [isLoading,setisLoading] =useState(true);

     if(inProgress === InteractionStatus.None && !isAuthenticated){
      //tackling 2 login redirect issue!
      
        if(accounts.length === 0){
          setTimeout(() => {
          instance.loginRedirect(loginRequest).catch(e => { console.log(e);});
        },500);
        }
       // console.log('here');
    
     }
     else if(isAuthenticated){
       //console.log('user is authenticated!');
      setTimeout(()=> {
        instance.acquireTokenSilent(request).then((response) => {
          setAccessToken(response.accessToken);
      }).then(()=>{
        setisLoading(false);
      // console.log('token :'+accessToken)
      })
      .catch((e) => {
          instance.acquireTokenPopup(request).then((response) => {
              setAccessToken(response.accessToken);
          });
      });
      },500)

     }

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="allmeasures">
      <Header />
      <Navbar  makebold="ALL"/>
      <AuthenticatedTemplate>
     <div> {isLoading?<div><ClipLoader color="#000000" size={20}/> Loading...</div>:<Cards accessToken={accessToken}/>}</div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div>Please LoginIn to view Content!</div>
      </UnauthenticatedTemplate>
    </div>
  );
}

